export default __webpack_public_path__ + "static/ggzsHover-95902bb678253860388577d3da49d529.png";